<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Add NODE</h6></div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <br />
  <form
    [formGroup]="formMasterGroup"
    #formDirective="ngForm"
    (ngSubmit)="submit()"
    novalidate
  >
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Select Site: <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>Select Site</mat-label>
            <mat-select
              [(ngModel)]="load.siteID"
              formControlName="siteNameCtr"
              required
            >
              <mat-option>Select Site</mat-option>
              <mat-option *ngFor="let item of sites" [value]="item.SiteId">{{
                item.SiteName
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('siteNameCtr', 'required')"
              >Please Select Site</mat-error
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Load Type: <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>--Select LoadType--</mat-label>
            <mat-select
              [(ngModel)]="load.type"
              formControlName="loadTypeCtr"
              (ngModelChange)="changeLoadType()"
            >
              <mat-option>--Select LoadType--</mat-option>
              <mat-option *ngFor="let item of loadTypes" [value]="item">{{
                item
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('loadTypeCtr', 'required')"
              >This field is required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <ng-container
          *ngIf="
            load.type !== 'Transformer' &&
            load.type !== 'Generic / Area Specific Sensor'
          "
        >
          <div class="col-md-4">
            <mat-label class="label-input pull-right"
              >Select Sub Type: <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-md-8">
            <mat-form-field>
              <mat-label>-- Select Load Sub Type --</mat-label>
              <mat-select
                [(ngModel)]="load.subType"
                formControlName="subTypeCtr"
                (ngModelChange)="changeSubLoadType()"
              >
                <mat-option>-- Select Load Sub Type --</mat-option>
                <mat-option
                  *ngFor="let item of loadSubTypes"
                  [value]="item.value"
                  >{{ item.text }}</mat-option
                >
              </mat-select>
              <mat-error *ngIf="isFieldHasError('subTypeCtr', 'required')"
                >Please Select Sub Type</mat-error
              >
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <div class="col-md-6">
        <div class="col-md-4">
          <mat-label class="label-input pull-right"
            >Select Load: <span class="iep-required">*</span></mat-label
          >
        </div>
        <div class="col-md-8">
          <mat-form-field>
            <mat-label>-- Select Load --</mat-label>
            <mat-select
              [(ngModel)]="load.rId"
              formControlName="loadCtr"
              (ngModelChange)="changeLoad()"
            >
              <mat-option>-- Select Load --</mat-option>
              <mat-option *ngFor="let item of loadDetails" [value]="item.rId">{{
                item.name
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldHasError('loadCtr', 'required')"
              >Please Select Load</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        load.subType === 'Hydraulic Unit' || load.subType === 'Generic Load'
      "
    >
      <div class="row">
        <div class="col-md-6">
          <div class="col-md-4">
            <mat-label class="label-input pull-right"
              >Load Image: <span class="iep-required">*</span></mat-label
            >
          </div>
          <div class="col-md-8">
            <input
              type="file"
              id="uploadLoadImage"
              formControlName="uploadLoadImageCtr"
              (change)="uploadDocument($event, 'Load')"
              class="hidden"
              accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
            />

            <button
              type="button"
              matTooltip="Select image"
              (click)="selectDocument('uploadLoadImage')"
              mat-icon-button
            >
              <mat-icon
                aria-hidden="false"
                aria-label="icon"
                class="bosch-ic-paperclip mat-icon Bosch-Ic"
                style="width: max-content"
              ></mat-icon></button
            >{{ loadAttachment.name }} <br />
            <mat-error
              class="upload-image-error"
              *ngIf="isFieldHasError('uploadLoadImageCtr', 'required')"
            >
              This field is required.
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div>
          <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <div id="wrapper" style="text-align: center; width: 100%">
              <canvas id="loadImgCanvas" width="0" height="0"></canvas>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row">
      <div class="col-md-12" style="text-align: center">
        <br />
        <button
          bciprimarybutton
          class="button-primary"
          type="submit"
          [disabled]="!formMasterGroup.valid"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="submit icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Submit
        </button>
        &nbsp;
      </div>
    </div>
  </form>
</mat-expansion-panel>
